import { render, staticRenderFns } from "./MyCreations.vue?vue&type=template&id=9022b34a&scoped=true"
import script from "./MyCreations.vue?vue&type=script&lang=js"
export * from "./MyCreations.vue?vue&type=script&lang=js"
import style0 from "./MyCreations.vue?vue&type=style&index=0&id=9022b34a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9022b34a",
  null
  
)

export default component.exports